// src/world/maps/interiors.ts — Interiores 12x10 cada uno
import { parseLayout } from '../tiles.js';
import type { Warp } from './villaAurelia.js';

export const INTERIOR_SIZE = { w: 12, h: 10 };

// Casa del jugador 12x10
const CASA_JUGADOR_L: string[] = [
  "MMMMMMMMMMMM",
  "MFFFFFFFFFFM",
  "MFFFFFFFFFFM",
  "MFFFRRFFFFFM",
  "MFFFRRFFFFFM",
  "MFFFFFFFFFFM",
  "MFFfFFFFfFFM",
  "MFFFFFFFFFFM",
  "MFFFFFDFFFFM", // puerta sur (6,8)
  "MMMMMMMMMMMM",
];

// Tienda — Bazar de Liora
const TIENDA_L: string[] = [
  "MMMMMMMMMMMM",
  "MFFFFFFFFFFM",
  "MFFRRFFRRFFM",
  "MFFRRFFRRFFM",
  "MFFFFFFFFFFM",
  "MFFfFFFFfFFM",
  "MFFFFFFFFFFM",
  "MFFFFFFFFFFM",
  "MFFFFFDFFFFM",
  "MMMMMMMMMMMM",
];

// Centro de descanso — Solea
const CENTRO_L: string[] = [
  "MMMMMMMMMMMM",
  "MFFFFFFFFFFM",
  "MFFAAFFAAFFM",
  "MFFAAFFAAFFM", // camas
  "MFFFFFFFFFFM",
  "MFFfFFFFfFFM",
  "MFFFFFFFFFFM",
  "MFFFFFFFFFFM",
  "MFFFFFDFFFFM",
  "MMMMMMMMMMMM",
];

// Casa del investigador
const CASA_NPC_L: string[] = [
  "MMMMMMMMMMMM",
  "MFFFFFFFFFFM",
  "MFFRRFFRRFFM",
  "MFFRRFFRRFFM",
  "MFFFffffFFFM",
  "MFFFffffFFFM",
  "MFFFFFFFFFFM",
  "MFFFFFFFFFFM",
  "MFFFFFDFFFFM",
  "MMMMMMMMMMMM",
];

import { CHAR_TO_TILE } from '../tiles.js';
function buildInterior(layout: string[], doorX: number, doorY: number, toZone: Warp['to'], toX:number, toY:number): { map:number[][], warps: Warp[] } {
  const map = layout.map(r => [...r].map(ch => CHAR_TO_TILE[ch] ?? 6));
  // puerta ya es 7 (D) en layout, confirmar
  // añadir warp salida
  const warps: Warp[] = [{ x: doorX, y: doorY, to: toZone, toX, toY, facing: 'south' }];
  return { map, warps };
}

export const INTERIORS = {
  casa_jugador: buildInterior(CASA_JUGADOR_L, 6, 8, 'villa_aurelia', 7, 7),
  tienda_aurelia: buildInterior(TIENDA_L, 6, 8, 'villa_aurelia', 22, 9),
  centro_aurelia: buildInterior(CENTRO_L, 6, 8, 'villa_aurelia', 9, 20),
  casa_npc: buildInterior(CASA_NPC_L, 6, 8, 'villa_aurelia', 21, 20),
} as const;
